import * as THREE from 'three'

const VacuumNative = (mesh: THREE.Object3D, onEnd: Function) => {
  let y = .1
  let paused = true
  let dir = 1
  let time: number | null = null
  let alpha = 0.05
  let minOffset = 1
  let duration = 3000
  
  return {
    update: () => {
      if(!paused) {
        if(dir === 1) {
          y = y >= 2 ? minOffset : y + alpha
        } else {
          y = y <= alpha ? 2 : minOffset
        }

        if(time && (time + duration < Date.now())) {
          paused = true
          time = null
          onEnd()
        }
        
        //@ts-ignore
        mesh.material.map.repeat.set(1, y)
      }
    },
    setPause: (pause: boolean, back?: boolean) => {
      paused = pause
      if(back !== undefined) paused = paused || !back

      if(paused) {
        time = null
      } else {
        time = Date.now()
      }
    },
  }
}

const WaterPreasure = (preasure: number, ending?: boolean) => (mesh: THREE.Object3D, onEnd: Function) => {
  let paused = true
  let opacityAlpha = 0.1 
  let rotationAlpha = 0.2 
  
  return {
    update: () => {
      //@ts-ignore
      const targetOpacity = (mesh.material.opacity + opacityAlpha * (paused ? -1 : 1))
      if(targetOpacity <= 1 && targetOpacity >= 0) {
        
        //@ts-ignore
        mesh.material.opacity = +targetOpacity.toFixed(1)
      }
      
      mesh.scale.set(targetOpacity / (preasure), 1, targetOpacity / (preasure))


      mesh.rotation.set(0, rotationAlpha + mesh.rotation.y, 0)
  },
    setPause: (pause: boolean, back?: boolean) => {
      paused = pause
      if(back !== undefined) paused = paused || !back

      console.log(pause, back)
    }
  }
}


const animations = [
  {
    name: 'VacuumNative',
    animation: VacuumNative
  },
  {
    name: 'WaterLvl0Native',
    animation: WaterPreasure(1, true)
  },
  {
    name: 'WaterLvl1Native',
    animation: WaterPreasure(1)
  },
  {
    name: 'WaterLvl2Native',
    animation: WaterPreasure(2)
  },
  {
    name: 'WaterLvl3Native',
    animation: WaterPreasure(3)
  },
]

export default (key: string) => {
  return animations.find(item => item.name === key)!.animation
}